module.exports = __webpack_public_path__ + "assets/b109.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b109.png
// module id = 580
// module chunks = 0